import angular from "angular";
import template from "./instructor-teamagenda.html";
import InstructorTeamAgendaController from "./instructor-teamagenda.controller";

function getSessionTypes(DriveSessionTypesModel) {
  return DriveSessionTypesModel.get().then((response) => {
    return response.sessionTypes;
  });
}
getSessionTypes.$inject = ["DriveSessionTypesModel"];

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.instructor.dashboard.teamagenda", {
    url: "/teamagenda/:date",
    controller: InstructorTeamAgendaController,
    controllerAs: "vm",
    template: template,
    resolve: {
      sessionTypes: getSessionTypes,
    },
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.owner,
        USER_ROLES.instructor,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("instructor.dashboard.teamagenda", [])
  .config(config)
  .controller("InstructorTeamAgendaController", InstructorTeamAgendaController);
